AppleID.auth.init({
  clientId: 'de.urlaubsgurugmbh.holidayguru-web',
  scope: 'name email',
  redirectURI: window.location.origin,
  state: 'Initial user authentication request',
  usePopup: true
});
